import React from 'react';
import { RouteComponentProps } from 'react-router';
import { Container, Row } from 'reactstrap';
import { getPropertyByKey } from '../../../../../api/Property';
import { useFetch } from '../../../../../hooks/useFetch';
import FormValidationDisplay from '../../../../common/form/ValidationDisplay';
import { LoadingDisplay } from '../../../../common/LoadingOverlay';
import '../../../../../styles/PropertyMapPage.css';
import Button from '../../../../common/form/Button';
import { browserHistory } from '../../../../../utilities/history';

export interface Props extends RouteComponentProps<{ propertySlug: string }> {}

const PropertyMapPage = (props: Props) => {
    const {
        data: propertyData,
        error: errorMessage,
        loading: mapLoading
    } = useFetch(() => getPropertyByKey(props.match.params.propertySlug), [], undefined);
    if (mapLoading) {
        return <LoadingDisplay />;
    }
    return (
        <Container className="property-map">
            <Row>
                <Button
                    text="Back"
                    addlClassName="btn-primary"
                    onClick={() => {
                        browserHistory.goBack();
                    }}
                />
            </Row>
            <Row>{propertyData && <img src={propertyData.mapLink} />}</Row>
            <FormValidationDisplay errorMessage={errorMessage} />
        </Container>
    );
};

export default PropertyMapPage;



// WEBPACK FOOTER //
// ./src/components/pages/prospect/public/properties/PropertyMapPage.tsx